import { skipToken, useQuery } from '@tanstack/react-query'

import { assetsApi } from '../../api/assets-api'
import { assetKeys } from '../../api/query-keys'

export function useAssetInventoryStats(entityId: string | null, includeChildren: boolean, enabled = true) {
  return useQuery({
    queryKey: assetKeys.stats(entityId ?? '', includeChildren),
    queryFn: entityId === null || !enabled
      ? skipToken
      : () => assetsApi.getStats(entityId, includeChildren),
  })
}
